import { Component, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { StorageService } from '@core/services/util/storage.service';
import { LoginService } from '@core/services/login/login.service';
import { ToastrService } from '@core/services/notification/toastr.service';
import { UtilityService } from '@core/services/util/utility.service';
import { CustomerService } from '@core/services/customer/customer.service';
import { AuthenticationService } from '@modules/authentication/services/authentication.service';
import { SentryBreadcrumbsService } from '@app/core/services/sentry-breadcrumbs.service';

import { LoginBaseComponent } from '@modules/authentication/components/login-base/login-base.component';

import { environment } from '@environment';
import { PonchoUIModule } from '@poncho/ui';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-mobile-login-with-password',
    templateUrl: './mobile-login-with-password.component.html',
    styleUrls: ['./mobile-login-with-password.component.scss'],
    standalone: true,
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, PonchoUIModule]
})
export class MobileLoginWithPasswordComponent extends LoginBaseComponent {
    signinForm: FormGroup;
    DEPLOY_URL: string;
    mobileNumber: string;

    constructor(
        public storageService: StorageService,
        public loginService: LoginService,
        public toastrService: ToastrService,
        public utilityService: UtilityService,
        public customerService: CustomerService,
        public authenticationService: AuthenticationService,
        public cdr: ChangeDetectorRef,
        public breadCrumb: SentryBreadcrumbsService
    ) {
        super(
            storageService,
            loginService,
            toastrService,
            utilityService,
            customerService,
            authenticationService,
            cdr,
            breadCrumb
        );
        this.DEPLOY_URL = environment.DEPLOY_URL;
        this.mobileNumber = this.storageService.get('phone_number');

        this.signinForm = new FormGroup({
            password: new FormControl('', Validators.compose([Validators.minLength(6)]))
        });
    }

    signIn() {
        if (!this.signinForm.valid) {
            this.utilityService.markFormFieldsAsTouched(this.signinForm);
            return;
        }

        this.btnLoading = true;
        this.signInWithPassword(this.signinForm.value.password);
    }
}
